module.exports = __webpack_public_path__ + "img/icmmena-logo.c5d57a16.svg";